var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isHtml)?_c('div',{class:['clamp', { 'italic-text': _vm.textItalic }],style:(_vm.clampStyling),domProps:{"innerHTML":_vm._s(_vm.htmlText)}}):_c('div',{class:['clamp', { 'italic-text': _vm.textItalic }],style:(_vm.clampStyling)},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }